import Mapbox from 'index.vue';
import { BaseLayer } from './baseLayer';
import { FeatureCollection, Point } from 'geojson';
import { feature } from '@turf/turf';

export class BaseFeatureLayer extends BaseLayer
{
    constructor(mapboxInstance: InstanceType<typeof Mapbox>, slot: string, layerName: string, sourceName: string, layerType: string, layout: any, paint: any, allowHover: boolean = false, showOutlines: boolean = false)
    {
        super(mapboxInstance, slot);
        this.layerName = layerName;
        this.sourceName = sourceName;
        this.layerType = layerType;
        this.layout = layout;
        this.paint = paint;
        this.toolTipOnHover = allowHover;
        
            
        if (!this.mapboxInstance.map.getSource(this.sourceName)) {
            const geojson: FeatureCollection<Point, any> = {
                type: 'FeatureCollection',
                features: [],
            };
            this.mapboxInstance.map.addSource(this.sourceName, {
                type: 'geojson',
                data: geojson,
            });
        }

        if (!this.mapboxInstance.map.getLayer(this.layerName)) {
            this.mapboxInstance.map.addLayer({
                id: this.layerName,
                type: this.layerType,
                slot: this.slot,
                source: this.sourceName,
                layout: this.layout,
                paint: this.paint
            });
        }
        if (showOutlines == true) {
            if (!this.mapboxInstance.map.getLayer(this.layerName + 'outlines')) {
                this.mapboxInstance.map.addLayer({
                    id: this.layerName + 'outlines',
                    type: 'line',
                    slot: 'top',
                    source: this.sourceName,
                    layout: {},
                    paint: {
                        'line-color': [
                            'case',
                            ['boolean', ['feature-state', 'hovered'], false],
                            '#333333',
                            ['get', 'outline-color']
                        ], 
                        'line-opacity': [
                            'case',
                            ['boolean', ['get', 'excluded'], false],
                            0,
                            1
                        ],
                        'line-width': [
                            'case',
                            ['boolean', ['feature-state', 'hovered'], false],
                            3,
                            1
                        ]

                    }
                });
            }

            this.mapboxInstance.map.on('mousemove', this.layerName, (e: any) => {
                e.features.sort((a: any, b: any) => (b.properties.zIndex || 0) - (a.properties.zIndex || 0));
                const hoveredFeature = e.features[0];
                const hoveredId = hoveredFeature.id;

                if (hoveredId === this.lastHoveredId) return; // no change

                if (this.lastHoveredId !== null) {
                    this.mapboxInstance.map.setFeatureState(
                        { source: this.sourceName, id: this.lastHoveredId },
                        { hovered: false }
                    );
                }

                this.mapboxInstance.map.setFeatureState(
                    { source: this.sourceName, id: hoveredId },
                    { hovered: hoveredFeature.properties.excluded == true ? false : true }
                );

                this.lastHoveredId = hoveredId;
            });
            this.mapboxInstance.map.on('mouseleave', this.layerName, () => {
                if (this.lastHoveredId !== null) {
                    this.mapboxInstance.map.setFeatureState(
                        { source: this.sourceName, id: this.lastHoveredId },
                        { hovered: false }
                    );
                    this.lastHoveredId = null;
                }
            });
        }
        
        if (this.toolTipOnHover) {
            this.mapboxInstance.map.on('mousemove', this.layerName, (e: any) => {
                e.features.sort((a: any, b: any) => (b.properties.zIndex || 0) - (a.properties.zIndex || 0));
                this.mapboxInstance.$emit('tooltipShow', { x: e.point.x, y: e.point.y, latitude: e.lngLat.lat, longitude: e.lngLat.lng, title: e.features[0].properties.title, titleHtml: e.features[0].properties.titleHtml });    
                
            });
        }
        
        mapboxInstance.map.addInteraction('contextmenu' + this.layerName, {
            type: 'contextmenu',
            target: { layerId: this.layerName },
            handler: (e: any) => {
                const point = this.mapboxInstance.map.project(e.lngLat);
                this.mapboxInstance.$emit('rightClick', { x: point.x, y: point.y, latitude: e.lngLat.lat, longitude: e.lngLat.lng });
            }
        });

        

        
        mapboxInstance.map.on('mouseleave', layerName, (e: any) => {
            if (e.features) e.features.sort((a: any, b: any) => (b.properties.zIndex || 0) - (a.properties.zIndex || 0));
            this.mapboxInstance.$emit('tooltipShow', { x: e.point.x, y: e.point.y, latitude: e.lngLat.lat, longitude: e.lngLat.lng, title: null, titleHtml: null });
        });

        
    }
    protected lastHoveredId: number | null = null;
    protected layerName: any = null;
    protected sourceName: any =null;
    protected layerType: any = null;
    protected layout: any = null;
    protected paint: any = null;
    protected toolTipOnHover: boolean = false;
    protected hoverOutline: boolean = false;
    

    public async SetFeatures(features: any) {
        const geojson: FeatureCollection<Point, any> = {
            type: 'FeatureCollection',
            features: features.map((feature: any, index: number) => {
                return {
                    ...feature,
                    id: index
                }
            }),
        };
        this.mapboxInstance.map.getSource(this.sourceName).setData(geojson);
    }
}